/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconLetterJSmall = createReactComponent("letter-j-small", "IconLetterJSmall", [
  ["path", { d: "M10 8h4v6a2 2 0 1 1 -4 0", key: "svg-0" }]
]);

export { IconLetterJSmall as default };
//# sourceMappingURL=IconLetterJSmall.js.map
